import { inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { GET_STORAGE_USAGE_MOCK } from '@shared/mocks/storage-usage.mock';

import { StorageUsageResponse } from './interfaces/storage-usage.interfaces';

import { HttpInterceptor } from '@interceptors/http/http.interceptor';

@Injectable({ providedIn: 'root' })
export class StorageUsageService {
  private readonly http = inject(HttpInterceptor);
  private readonly apiUrl = 'storage-usage';

  public getStorageUsage(): Observable<StorageUsageResponse> {
    return this.http.get(this.apiUrl, GET_STORAGE_USAGE_MOCK);
  }
}
